import React from 'react';
import classes from './InputLabel.scss';

const InputLabel = (props) => {
    return (
        <label className={[classes.Label, props.isActive ? classes.LabelActive : null].join(' ')} style={{left: 0}}>{props.children}</label>
    );
}

export default InputLabel;


// WEBPACK FOOTER //
// ./src/components/UI/InputLabel/InputLabel.js